import { render, staticRenderFns } from "./userModBtn.vue?vue&type=template&id=7074c569&"
import script from "./userModBtn.vue?vue&type=script&lang=js&"
export * from "./userModBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports